import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import {IconButton, Tooltip} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import {showLeftDrawer, showRightDrawer} from '../../actions/ui.js';

const CollapseButton = ({
  direction = 'left',
  onClick,
  title = 'Collapse Sidebar',
  closeLeftDrawer,
  closeRightDrawer,
  ...props
}) => {
  const handleClick = () => {
    direction === 'left' ? closeLeftDrawer() : closeRightDrawer();
  };

  return (
    <Tooltip title={title}>
      <IconButton
        color="default"
        size="small"
        data-qe="collapse-sidebar"
        onClick={handleClick}
        {...props}
      >
        <ArrowBackIosNewIcon
          fontSize="small"
          sx={{
            transform: direction === 'right' ? 'scaleX(-1)' : 'none',
          }}
        />
      </IconButton>
    </Tooltip>
  );
};

CollapseButton.propTypes = {
  direction: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string,
  closeRightDrawer: PropTypes.func,
  closeLeftDrawer: PropTypes.func,
};

const mapDispatchProps = {
  closeRightDrawer: () => showRightDrawer(''),
  closeLeftDrawer: () => showLeftDrawer(''),
};

export default connect(null, mapDispatchProps)(CollapseButton);
